import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { X, AlertCircle } from 'lucide-react';
import { Button } from './ui/button';

const AnnouncementPopup = () => {
  const [isVisible, setIsVisible] = useState(false);
  const location = useLocation();

  useEffect(() => {
    // Only show on homepage (exact path "/")
    if (location.pathname !== '/') {
      return;
    }
    
    // Check if user has already seen the announcement
    const hasSeenAnnouncement = localStorage.getItem('hasSeenAnnouncement');
    
    if (!hasSeenAnnouncement) {
      // Show popup after a short delay
      const timer = setTimeout(() => {
        setIsVisible(true);
      }, 1000);
      
      return () => clearTimeout(timer);
    }
  }, [location.pathname]);

  const handleClose = () => {
    setIsVisible(false);
    // Remember that user has seen the announcement
    localStorage.setItem('hasSeenAnnouncement', 'true');
  };

  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg shadow-2xl max-w-md w-full p-6 relative animate-in fade-in zoom-in duration-300">
        {/* Close button */}
        <button
          onClick={handleClose}
          className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors"
        >
          <X className="h-5 w-5" />
        </button>

        {/* Icon */}
        <div className="flex justify-center mb-4">
          <div className="bg-orange-100 rounded-full p-3">
            <AlertCircle className="h-8 w-8 text-orange-600" />
          </div>
        </div>

        {/* Content */}
        <div className="text-center">
          <h2 className="text-2xl font-bold text-gray-900 mb-3">
            Welcome to Profind.ca!
          </h2>
          <p className="text-gray-600 mb-4 leading-relaxed">
            We're excited to have you here! Profind.ca is a brand new platform connecting homeowners with trusted local professionals across Canada.
          </p>
          <p className="text-gray-600 mb-6 leading-relaxed">
            Please be patient as we're actively building our database of professional contractors and service providers. Check back regularly as we add more pros to serve you better!
          </p>

          {/* CTA Button */}
          <Button
            onClick={handleClose}
            className="w-full bg-orange-600 hover:bg-orange-700 text-white font-semibold"
          >
            Got It, Thanks!
          </Button>
        </div>
      </div>
    </div>
  );
};

export default AnnouncementPopup;
